/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraaspEuDescription } from '../../models/graasp-eu-description';

export interface GraaspEuIlsImportControllerFindAll$Params {
}

export function graaspEuIlsImportControllerFindAll(http: HttpClient, rootUrl: string, params?: GraaspEuIlsImportControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GraaspEuDescription>>> {
  const rb = new RequestBuilder(rootUrl, graaspEuIlsImportControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GraaspEuDescription>>;
    })
  );
}

graaspEuIlsImportControllerFindAll.PATH = '/graasp-eu-ils-import';
